import React from 'react';
import { hydrate } from 'react-dom';
import { Provider } from 'react-redux';
import { IntlProvider } from 'react-intl';
import serverVars from 'server-vars';
import { actionCreators } from '../actions';

const getBuyerFooterClient = async ({ node, store, relayEnv }) => {
    const isMobile = serverVars.get('settings.isMobile');

    let navPromise;
    let messageBannerPromise = Promise.resolve({});

    if (!isMobile) {
        navPromise = import(
            /* webpackChunkName: "responsiveFooter" */ '../components/responsiveFooter'
        );
    } else {
        navPromise = import(/* webpackChunkName: "mobileFooter" */ '../components/mobileFooter');

        messageBannerPromise = import(
            /* webpackChunkName: "MessageBanner" */ '../components/MessageBanner/MessageBanner'
        );
    }

    const { FooterRenderer, footerInitialVariables, footerRootQuery } = await navPromise;
    const { default: MessageBannerRenderer } = await messageBannerPromise;

    const localeDataKey = serverVars.get('localeDataKey');
    const messages = serverVars.get('messages');

    let props = {
        environment: relayEnv,
        initialVariables: footerInitialVariables,
        query: footerRootQuery,
    };

    if (MessageBannerRenderer) {
        props = {
            ...props,
            messageBannerRenderer: messageBannerRendererProps => (
                <MessageBannerRenderer {...messageBannerRendererProps} />
            ),
        };
    }

    hydrate(
        <IntlProvider locale={localeDataKey} messages={messages}>
            <Provider store={store}>
                <FooterRenderer {...props} />
            </Provider>
        </IntlProvider>,
        node
    );

    return {
        updateUserState: store.dispatch.bind(null, actionCreators.setUpdateUserState(true)),
    };
};

export { getBuyerFooterClient };
